<template>
    <router-view></router-view>
</template>

<script>

// import MainPage from '@/components/views/MainPage.vue'
// import Reg from '@/components/login/Register.vue'
export default {
  name: 'App',
  data(){
      return{
          msg:"Log"
      }
  },
  components: {
    
  }
}
</script>

<style>
@import './style/common.scss';
@import './style/font/css/font-awesome.min.css';
#app{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}
.title{
    text-align: center;
    background-image: linear-gradient(to right, #fbc2eb, #a6c1ee);
}
.btn {
    background-color: rgb(210,193,326);
    border-radius:28px;
    border:1px solid #ffffff;
    display:inline-block;
    cursor:pointer;
    color:#ffffff;
    font-family:Arial;
    font-size:17px;
    padding:16px 31px;
    text-decoration:none;
    text-shadow:0px 1px 0px #2f6627;
    margin: 10px 20px;
}
.btn:hover {
    background-color:rgb(180,193,237);
}
.btn:active {
    position:relative;
    top:1px;
}
.el-breadcrumb{
    padding:20px 0;
}
</style>
